import React from 'react'
import PropTypes from 'prop-types'
import { Svg } from '../../1_Atoms/Svg/Svg'
import { languageController } from '../../../controllers/language/languageController'

function AutoComplete({
  input,
  results,
  onClick,
  onReset,
  isActive,
  isSelected
}) {

  return (
    <div className="mz-auto-complete">
      {input}
      <div className="mz-auto-complete__icon">
        {
          isSelected ? (
            <button
              className="mz-auto-complete__reset reset font-base medium"
              onClick={onReset}
            >
              {languageController.getCopy('global', 'change')}
            </button>
          ) : (
              <Svg type="search" size={1.3} colour="grey" />
            )
        }
      </div>
      <div className="mz-auto-complete__results" aria-hidden={!isActive}>
        {
          results.length > 0 ? (
            results.map(result => (
              <a key={result.id} className="mz-auto-complete__item" onClick={() => onClick(result)}>{result.label}</a>
            ))
          ) : (
              <div className="mz-auto-complete__empty-message">{languageController.getCopy('global', 'noResults')}</div>
            )
        }
      </div>
    </div>
  )
}

AutoComplete.propTypes = {
  input: PropTypes.object.isRequired,
  results: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired
}

AutoComplete.defaultProps = {
  results: [],
  isActive: false,
  isSelected: false,
}

export default AutoComplete